import { render, staticRenderFns } from "./RoomTemplate.vue?vue&type=template&id=9c044504&scoped=true&"
import script from "./RoomTemplate.vue?vue&type=script&lang=js&"
export * from "./RoomTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RoomTemplate.vue?vue&type=style&index=0&id=9c044504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c044504",
  null
  
)

export default component.exports